import React, { useMemo } from "react";
import './HalfViews.css';
import { androidUrl, appleUrl, AppStoreButton, PlayStoreButton } from "../Landing";
import Grid from "../../../Components/Grid/grid";

interface HalfViewsProps {
    backgroundColor?: string;
    imageLeft: boolean;
    imageStrings: string[];
    imageAlt: string;
    title: string;
    description: string;
    isMobile?: boolean; // Assuming you have a way to determine if it's mobile
    showGrid?: boolean;
    gradient?: {
        top: string;
        bottom: string;
    }
}

const HalfViews = ({
    backgroundColor = '#ffffff',
    imageLeft = true,
    imageStrings,
    imageAlt,
    title,
    description,
    isMobile = false, // Assuming you have a way to determine if it's mobile
    showGrid = false,
    gradient,
}: HalfViewsProps) => {

    const roatationVal = 7; // Adjust this value to change the rotation effect

    const ImageView = useMemo(() => {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'fit-content',
                    justifyContent: 'center',
                    alignItems: 'center',
                    transform: `${(imageStrings.length > 3 && !isMobile) ? `translateX(${60 * imageStrings.length}px)` : 'translateX(0px)'}`,
                }}
            >
                <div 
                    className={`image-view-container ${ imageStrings.length > 2 ? ' greater-than-2' : ''}`}
                    style={{
                        display: 'flex',
                        height: 'fit-content',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transform: `${(imageStrings.length > 2) ? `translateX(${60 * imageStrings.length}px)` : 'translateX(0px)'}`,
                    }}
                >
                    {imageStrings.map((imgString, index) => {
                        return ( 
                            <img
                                className={`image-view image-item-${index}${ imageStrings.length > 2 ? ' greater-than-2' : ''}`}
                                src={imgString}
                                alt={imageAlt}
                                style={{ 
                                    zIndex: imageStrings.length - index, 
                                    transform:
                                     
                                    (imageStrings.length === 3 && isMobile) ? 
                                    `${ (index === 0) ? 'translateX(70px) rotate(-10deg)' : (index === 1) ? 'translateX(0px)' : 'translateX(-70px) rotate(10deg)' }`
                            
                                    :
                                    `translateX(${(index > 0) ? (imageStrings.length < 3) ? (-index * 25) : (-index * 150) : (imageStrings.length > 1) ? 25 : 0}px) 
                                        rotate(${ 
                                        (imageStrings.length > 1) ? 
                                            (imageStrings.length > 2) ? 
                                                -((roatationVal - 4.1) * imageStrings.length) + ((roatationVal -3.1) * (index * (2.5)))
                                            : (((index % 2 ) === 0) ? -roatationVal : roatationVal) : 
                                        0
                                        }deg)`, 
                                    boxShadow: `0px 0px ${ 10}px rgba(0, 0, 0, ${0})`,
                                    opacity: 1 - (index * 0.025),
                                }}
                            />
                        )
                    })
                    }
                </div>
                <div className='authentication-buttons'
                    style={{
                        display: 'flex',
                        flexDirection: isMobile? "column" : 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 30,
                        marginTop: 50,
                    }}
                >
                    <AppStoreButton 
                        size='large' color='black' shadow={false} 
                        onClick={() => window.open(appleUrl, '_blank')} 
                        backgroundColor="rgba(0,0,0,0)"
                        border
                        borderColor="rgba(0,0,0)"
                        borderWidth={2}
                    />
                    <PlayStoreButton 
                        size='large' color='black' shadow={false} 
                        onClick={() => window.open(androidUrl, '_blank')} 
                        backgroundColor="rgba(0,0,0,0)"
                        border
                        borderColor="rgba(0,0,0)"
                        borderWidth={2}
                    />
                </div>
            </div>
        );
    }, [ imageStrings , imageAlt ]);

    const TextView = useMemo(() => {
        return (
            <div className="text-view">
                <h1 dangerouslySetInnerHTML={{ __html: title}} />
                <p dangerouslySetInnerHTML={{ __html: description}}/>
            </div>
        );
    }, [title, description]);


    const MainContent = useMemo(() => {
        return (
            <div className="HalfViews" style={{
                background: gradient ? `linear-gradient(${gradient.top}, ${gradient.bottom})` : backgroundColor,
                backgroundColor: 'transparent', 
            }}>
                <div className="half-view left-view">
                    {imageLeft && ImageView}
                    {!imageLeft && TextView }
                </div>
                <div className="half-view right-view">
                    {imageLeft && TextView }
                    {!imageLeft && ImageView }
                </div>
            </div>
        )
    }, [backgroundColor, isMobile]);

    const GridMainContent = useMemo(() => {
        return (<Grid animated={true} dotSize={1} spacing={20} color="#000000" opacity={0.15}> { MainContent }</Grid>)
    }, []);


    return (
        <div className="HalfViews-Container" style={{ backgroundColor: backgroundColor, }}>
         { MainContent }
        </div>
    );
}

export default HalfViews;